module.exports = __webpack_public_path__ + "img/logo.4ddd816b.png";